export function roundOffNumber(num) {
  const decimal = num % 1;
  if (decimal >= 0.5) {
    return Math.ceil(num);
  } else {
    return Math.floor(num);
  }
}
